import { SuperDate } from '@razlet/utils';

const STATUSES = {
  0: 'created',
  1: 'confirmed',
  2: 'waitProcessing',
  3: 'rejected',
  4: 'notLoaded',
  5: 'infoRequest',
  6: 'infoRequest',
  7: 'merged',
  8: 'rejected',
};

const IMPORTANT_STATUSES = [
  STATUSES['1'],
];

const CRITICAL_STATUSES = [
  STATUSES['3'],
  STATUSES['4'],
  STATUSES['8'],
];

const WARNING_STATUSES = [
  STATUSES['5'],
  STATUSES['6'],
];

const SUCCESS_STATUSES = [
  STATUSES['1'],
];

const NOT_ACTIVE_STATUSES = [
  STATUSES['0'],
];

export default class RaidPreliminaryInforming {
  data = null;

  date = null;

  message = '';
  state = '';

  constructor (data) {
    this.data = data;

    if (data.timestamp) this.date = new SuperDate(data.timestamp);
    if (data.message) this.message = data.message;

    this.state = data.state;
  }

  get status () {
    return STATUSES[this.state] || '';
  }

  get statusNumber () {
    return this.state;
  }

  get isImportant () {
    return IMPORTANT_STATUSES.includes(this.status);
  }

  get isWarning () {
    return WARNING_STATUSES.includes(this.status);
  }

  get isCritical () {
    return CRITICAL_STATUSES.includes(this.status);
  }

  get isSuccess () {
    return SUCCESS_STATUSES.includes(this.status);
  }

  get isNotActive () {
    return NOT_ACTIVE_STATUSES.includes(this.status);
  }
};
